<template>
  <v-container style="min-height:80vh">
    <v-row v-if="serverCount !== null && serverCount > 0 || search !=''" justify="center">
      <v-col cols="11">
        <v-row
          justify="space-between"
          self-align="center"
          class="mb-2"
        >
          <v-col cols="auto">
            <h2> Jobs </h2>
          </v-col>
          <v-col cols="auto">
            <v-btn
              color="primary"
              @click="jobCreation"
              data-cy="job-table-btn-add"
            >
              Add Job
            </v-btn>
          </v-col>
        </v-row>
        <v-data-table
          :headers="headers"
          :items="jobs"
          :options.sync="options"
          :loading="loading"
          :items-per-page="25"
          :footer-props="{'items-per-page-options':[5, 10, 25, 50]}"
          :server-items-length="serverCount"
          show-expand
          class="elevation-1"
        >
          <template v-slot:top>
            <v-text-field
              v-model="search"
              label="Search"
              clearable
              prepend-inner-icon="mdi-magnify"
              class="mx-4"
              @input="getData()"
            />
          </template>
          <template v-if="isSuperUser" #item.hash="{ item }">
            <a
              target="_blank"
              :href="item.payrollProvider.name == 'Invoice' ? `/submissions/invoice/${item.hash}` : item.jobType == 'DOT' ? `/submissions/dot/${item.hash}` : item.payrollProvider.name == 'Revolution' ? `/submissions/revolution/${item.hash}` : item.payrollProvider.name == 'Starting Paperwork' ? `/submissions/StartingPaperwork/${item.hash}` : item.payrollProvider.name == 'CAPS Cast and Crew' && (item.market.name == 'Ontario' || item.market.name == 'British Columbia') ? `/submissions/canada/${item.hash}` : `/submissions/${item.hash}`"
            >
              <v-btn
                rounded
                color="primary"
              >
                Job Link
              </v-btn>
            </a>
          </template>
          <template v-else #item.hash="{ item }">
            <a
              v-if="item.hasPaid && !isSuperUser"
              target="_blank"
              :href="item.payrollProvider.name == 'Invoice' ? `/submissions/invoice/${item.hash}` : item.jobType == 'DOT' ? `/submissions/dot/${item.hash}` : item.payrollProvider.name == 'Revolution' ? `/submissions/revolution/${item.hash}` : item.payrollProvider.name == 'Starting Paperwork' ? `/submissions/StartingPaperwork/${item.hash}` : item.payrollProvider.name == 'CAPS Cast and Crew' && (item.market.name == 'Ontario' || item.market.name == 'British Columbia') ? `/submissions/canada/${item.hash}` : `/submissions/${item.hash}`"
            >
              <v-btn
                rounded
                color="primary"
              >
                Job Link
              </v-btn>
            </a>
            <v-tooltip v-else top>
              <template v-slot:activator="{ on, attrs }">
                  <v-icon 
                    v-bind="attrs"
                    v-on="on"
                  > 
                    mdi-cancel 
                  </v-icon>
              </template>
              <span>Must pay for job to get link</span>
            </v-tooltip>
          </template>
          <template #item.hasPaid="{ item }">
            <v-icon>
              {{ item.hasPaid ? 'mdi-check' : 'mdi-close' }}
            </v-icon>
          </template>
          <template #item.endsOn="{ item }">
              {{ toReadableDate(item.endsOn) }}
          </template>
          <template v-slot:expanded-item="{ item }">
            <td
              class="py-3"
              colspan="12"
            >
              <h3>{{ `${item.name} ${item.number}` }}
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        :to="{name: 'job-details', params: {jobId: item.id}}"
                        :data-cy="`job-table-icon-view-${jobs.indexOf(item.id)}`"
                      >
                      <v-icon > mdi-eye </v-icon>
                    </v-btn>
                  </template>
                  View Details
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-if="isSuperUser"
                      icon
                      v-bind="attrs"
                      v-on="on"
                      :to="{name: 'jobs-admin-edit', params: {jobId: item.id}}"
                      :data-cy="`job-admin-table-icon-wrench${jobs.indexOf(item.id)}`"
                    >
                    <v-icon > mdi-wrench </v-icon>
                    </v-btn>
                    <v-btn
                      v-else
                      icon
                      v-bind="attrs"
                      v-on="on"
                      :to="{name: 'jobs-edit', params: {jobId: item.id}}"
                      :data-cy="`job-table-icon-wrench${jobs.indexOf(item.id)}`"
                    >
                    <v-icon > mdi-wrench </v-icon>
                    </v-btn>
                  </template>
                  Edit Job
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn 
                      icon
                      v-bind="attrs"
                      v-on="on"
                      target="_blank"
                      v-if="!item.hasPaid"
                      :href="`/checkout/${item.hash}`"
                    >
                      <v-icon > mdi-currency-usd </v-icon>
                    </v-btn>
                  </template>
                  <span>Checkout Page (Pay Now)</span>
                </v-tooltip>

                <v-dialog
                  v-if="isSuperUser"
                  v-model="markHasPaid"
                  width="500"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      v-on="on"
                    >
                      <v-icon> mdi-check-bold </v-icon>
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      Are you sure you want to mark this job as paid?
                    </v-card-title>
                    <v-card-actions>
                      <v-row justify="end">
                        <v-col cols="auto">
                          <v-btn
                            text
                            @click="() => markHasPaid = false"
                          >
                            CANCEL
                          </v-btn>
                        </v-col>
                        <v-col cols="auto">
                          <v-btn
                            color="error"
                            text
                            @click="changeToHasPaid(item.id)"
                          >
                            MARK HAS PAID
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn 
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click="downloadInvoice(item.hash)"
                    >
                      <v-icon > mdi-file </v-icon>
                    </v-btn>
                  </template>
                  <span>Generate Invoice</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn 
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click="downloadQrcode(item.hash)"
                    >
                      <v-icon > mdi-qrcode </v-icon>
                    </v-btn>
                  </template>
                  <span>Generate QR Code</span>
                </v-tooltip>
                <v-dialog
                  v-if="isSuperUser"
                  v-model="jobDelete"
                  width="500"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      v-on="on"
                    >
                      <v-icon> mdi-delete </v-icon>
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      Are you sure you want to delete this job?
                    </v-card-title>
                    <v-card-actions>
                      <v-row justify="end">
                        <v-col cols="auto">
                          <v-btn
                            text
                            @click="() => jobDelete = false"
                          >
                            CANCEL
                          </v-btn>
                        </v-col>
                        <v-col cols="auto">
                          <v-btn
                            color="error"
                            text
                            @click="deleteJob(item.id)"
                          >
                            DELETE JOB
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-btn
                  v-if="item.folderId!==null"
                  rounded
                  color="primary"
                  @click="downloadSubmissions(item.folderId)"
                >
                  Download Submissions
                </v-btn>
              </h3>
              
              <v-row
                no-gutters
                wrap
              >
                <v-col
                    cols="12"
                    class="mb-4"
                    md="4"
                >
                  <v-card
                    flat
                    tile
                    class="pa-2"
                  >
                    <v-row no-gutters>
                      <v-col cols="12">
                        <b> Company: </b> {{ item.company.name }}
                      </v-col>
                      <v-col
                        v-if="item.manager"
                        cols="12"
                      >
                        <b> Manager: </b> {{ `${item.manager.firstName}
                  ${item.manager.lastName} (${item.manager.email})` }}
                      </v-col>
                      <v-col
                        v-if="item.notes"
                        cols="12"
                      >
                        <b> Notes for Freelancers: </b> {{ `${item.notes}` }}
                      </v-col>
                      <v-col
                        v-if="item.code && isSuperUser"
                        cols="12"
                      >
                        <b> Code: </b> {{ `${item.code}` }}
                      </v-col>
                      <v-col
                        v-else-if="item.code && item.hasPaid"
                        cols="12"
                      >
                        <b> Code: </b> {{ `${item.code}` }}
                      </v-col>
                      <v-col
                        v-if="item.users"
                        cols="12"
                      >
                        <b> Users: </b>
                        <div
                          v-for="(user, i) in item.users"
                          :key="i"
                        >
                          {{ user.firstName }} {{ user.email }}
                        </div>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>

                <v-col
                    cols="12"
                    class="mb-4"
                    md="4"
                >
                  <v-card
                    flat
                    tile
                    class="pa-2"
                  >
                    <v-row no-gutters>
                      <v-col cols="12">
                        <b> Price: </b> {{ `$${item.price}` }}
                      </v-col>
                      <v-col
                        cols="12"
                      >
                        <b> Created At: </b> {{ shortFormatDate(item.createdAt) }}
                      </v-col>
                      <v-col
                        cols="12"
                      >
                        <b> Modified At: </b> {{ shortFormatDate(item.modifiedAt) }}
                      </v-col>
                      <v-col
                        cols="12"
                      >
                        <b> Travel: </b> <v-icon small>
                          {{ item.hasTravel ? 'mdi-check' : 'mdi-close' }}
                        </v-icon>
                      </v-col>
                      <v-col
                        cols="12"
                      >
                        <b> Out of Zone: </b> <v-icon small>
                          {{ item.hasOutOfZone ? 'mdi-check' : 'mdi-close' }}
                        </v-icon>
                      </v-col>
                      <v-col
                        cols="12"
                      >
                        <b> Employee Start Form: </b> <v-icon small>
                          {{ item.hasEmployeeStartForm ? 'mdi-check' : 'mdi-close' }}
                        </v-icon>
                      </v-col>
                      <v-col
                        cols="12"
                      >
                        <b> Payroll Provider: </b>
                        {{ item.payrollProvider.name }}
                      </v-col>
                      <v-col
                        cols="12"
                      >
                        <b> Market: </b>
                        {{ item.market.name }}
                      </v-col>
                      <v-col
                        cols="12"
                      >
                        <b> Is NDA Included: </b>
                        {{ item.isNdaIncluded }}
                      </v-col>
                      <v-col
                        v-if="item.payDay"
                        cols="12"
                      >
                        <b> Pay Day: </b>
                        {{ item.payDay }}
                      </v-col>
                      <v-col
                        v-if="item.payDayFrequency"
                        cols="12"
                      >
                        <b> Pay Day Frequency: </b>
                        {{ item.payDayFrequency }}
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>

                <v-col
                    cols="12"
                    class="mb-4"
                    md="4"
                >
                  <v-card
                    v-if="item.artCode && item.artCoordinator"
                    color="accent"
                    flat
                    tile
                    style="color:white"
                    class="pa-2"
                  >
                    <v-row no-gutters>
                      <v-col
                        cols="12"
                      >
                        <b> Art Coordinator: </b> {{ `${item.artCoordinator.firstName}
                  ${item.artCoordinator.lastName} (${item.artCoordinator.email})` }}
                      </v-col>
                      <v-col
                        v-if="isSuperUser"
                        cols="12"
                      >
                        <b> Art Code: </b> {{ `${item.artCode}` }}
                      </v-col>
                      <v-col
                        v-else-if="item.hasPaid"
                        cols="12"
                      >
                        <b> Art Code: </b> {{ `${item.artCode}` }}
                      </v-col>
                      <v-col
                        v-if="isSuperUser"
                      >
                        <b> Art Link: </b>
                        <a
                          target="_blank"
                          :href="item.payrollProvider.name == 'Revolution' ? `/submissions/art/revolution/${item.hash}` : item.payrollProvider.name == 'Starting Paperwork' ? `/submissions/art/StartingPaperwork/${item.hash}` : item.payrollProvider.name == 'CAPS Cast and Crew' && (item.market.name == 'Ontario' || item.market.name == 'British Columbia') ? `/submissions/canada/${item.hash}` : `/submissions/art/${item.hash}`"
                        >
                          <v-icon color="white"> mdi-link </v-icon>
                        </a>
                      </v-col>
                      <v-col
                        v-else-if="item.hasPaid"
                      >
                        <b> Art Link: </b>
                        <a
                          target="_blank"
                          :href="item.payrollProvider.name == 'Revolution' ? `/submissions/art/revolution/${item.hash}` : item.payrollProvider.name == 'Starting Paperwork' ? `/submissions/art/StartingPaperwork/${item.hash}` : item.payrollProvider.name == 'CAPS Cast and Crew' && (item.market.name == 'Ontario' || item.market.name == 'British Columbia') ? `/submissions/canada/${item.hash}` : `/submissions/art/${item.hash}`"
                        >
                          <v-icon color="white"> mdi-link </v-icon>
                        </a>
                      </v-col>
                      <v-col
                        v-if="isSuperUser"
                      >
                        <b> Art QR Code: </b>
                        <button
                          icon
                          @click="downloadArtQrcode(item.hash)"
                        >
                          <v-icon color="white"> mdi-qrcode </v-icon>
                        </button>
                      </v-col>
                      <v-col
                        v-else-if="item.hasPaid"
                      >
                        <b> Art QR Code: </b>
                        <button
                          icon
                          @click="downloadArtQrcode(item.hash)"
                        >
                          <v-icon color="white"> mdi-qrcode </v-icon>
                        </button>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </td>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <JobTableNullState v-if="serverCount === 0 && search === ''" />
  </v-container>
</template>

<script>
import { DateTime } from 'luxon';
import { jobTable, changeToHasPaid, deleteJob } from '../services/jobs';
import { getUser } from '../services/users';
import { generateInvoice, generateQrcode, generateArtQrcode } from '../services/jobs';
import JobTableNullState from '../components/JobTableNullState.vue';

export default {
  components: {
    JobTableNullState
  },
  data() {
    return {
      headers: [
        { text: 'Name', align: 'start', value: 'name' },
        { text: 'Job Link', name: 'link', align: 'center', value: 'hash', },
        { text: 'Number', align: 'start', value: 'number' },
        { text: 'Company', align: 'start', value: 'company.name' },
        { text: 'Has Paid', align: 'start', value: 'hasPaid' },
        { text: 'End Date', align: 'start', value: 'endsOn' },
      ],
      jobs: [],
      rowsPerPageItems: [5, 10, 10],
      options: {},
      loading: false,
      serverCount: null,
      deleteDialog: false,
      search: '',
      isSuperUser: false,
      markHasPaid: false,
      jobDelete: false,
    };
  },
  watch: {
    options: {
      handler() {
        this.getData();
        console.log('search = ' + this.search);
      },
      deep: true,
    },
  },
  async mounted() { 
    await this.getData();
    console.log('server count = ' + this.serverCount);
  },
  methods: {
    async getData() {
      this.loading = true;
      const { data } = await jobTable(this.search, this.options?.page, this.options?.itemsPerPage);
      this.serverCount = data?.count;
      this.jobs = data?.results;
      this.loading = false;
      let current_user = await getUser();
      this.isSuperUser = current_user['data']['is_superuser'];
    },
    shortFormatDate(isoString) {
      return isoString ? DateTime.fromISO(isoString)
        .toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS) : 'Null';
    },
    toReadableDate(isoString) {
      return DateTime.fromISO(isoString).toFormat('MM-dd-yyyy');
    },
    async changeToHasPaid(id){
      this.markHasPaid = false;
      await changeToHasPaid(id);
      await this.getData();
    },
    async deleteJob(id){
      this.jobDelete = false;
      await deleteJob(id);
      await this.getData();
    },
    jobCreation(){
      if (this.isSuperUser){
        this.$router.push({ name: "jobs-create-admin"})
      }
      else {
        this.$router.push({ name: "jobs-create"})
      }
    },
    downloadSubmissions(folder_id){
      let url = 'https://freelancepaymentsystems.app.box.com/folder/' + folder_id
      window.open(url, '_blank').focus();
    },
    async downloadInvoice(hash) {
      const { data } = await generateInvoice(hash);
      // create a blobURI pointing to our Blob
      const objectUrl = URL.createObjectURL(new Blob([data], { type: 'application/pdf' }));
      window.open(objectUrl)
    },
    async downloadQrcode(hash) {
      const { data } = await generateQrcode(hash);
      // create a blobURI pointing to our Blob
      const objectUrl = URL.createObjectURL(new Blob([data], { type: 'application/pdf' }));
      window.open(objectUrl)
    },
    async downloadArtQrcode(hash) {
      const { data } = await generateArtQrcode(hash);
      // create a blobURI pointing to our Blob
      const objectUrl = URL.createObjectURL(new Blob([data], { type: 'application/pdf' }));
      window.open(objectUrl)
    }
  },
};
</script>

<style>

</style>
